module.exports = "/img/ai.0c400d0f.png";